import * as React from 'react';

import {CloseButton} from '../button/close-button/close-button';
import {Dialog} from '../dialog/dialog';

type Props = {
    onClose: () => void;
};

export function ChecklistCloseButton(props: Props) {
    const [showDialog, setShowDialog] = React.useState(false);
    const closeButtonRef = React.useRef<HTMLButtonElement | null | undefined>(null);

    return (
        <>
            <CloseButton
                getRef={(node) => {
                    closeButtonRef.current = node;
                }}
                onClick={() => {
                    setShowDialog(true);
                }}
                size={17}
            />
            {showDialog && (
                <Dialog
                    anchor={closeButtonRef.current}
                    question='Are you sure you want to hide this checklist? Once it’s hidden, you won’t be able to get it back.'
                    primaryText='Yes, hide it'
                    secondaryText='No, keep it'
                    isWarning={true}
                    onPrimary={props.onClose}
                    onSecondary={() => {
                        setShowDialog(false);
                    }}
                    location='bottom'
                />
            )}
        </>
    );
}
